<template>
  <v-container>
    <v-row>
      <v-col>
        <!-- Stripe Account Component -->
        <StripeAccount />

        <!-- Logout Section -->
        <v-card class="mx-auto mt-4" max-width="400" min-height="100">
          <v-card-text class="text-h5 pb-0">
            <v-btn outlined rounded color="primary" dark class="ml-14" @click="logoutDialog = true">Logout</v-btn>
          </v-card-text>
        </v-card>

        <!-- Logout Dialog -->
        <v-dialog v-model="logoutDialog" max-width="290">
          <v-card>
            <v-card-title class="headline"> Logout? </v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="error" class="mr-4" text href="/logout"> Logout </v-btn>
              <v-btn class="mr-4 main-btn" outlined color="gray" text @click="logoutDialog = false"> Cancel </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
/* eslint-disable no-debugger */

import StripeAccount from '@/components/stripe/StripeAccount.vue';

export default {
  name: 'Settings',

  components: {
    StripeAccount
  },

  data: () => ({
    logoutDialog: false
  }),

  mounted() {
    document.title = 'Settings';
  }
};
</script>
<style></style>
